import React from "react";
import {useTranslation} from "react-i18next";
import CONST from "../../config/CONST";

const FormLayerThankyou = () => {

    const { t } = useTranslation();

    return (
        <div className={`${CONST.CSS_NAMESPACE}FormLayerThankyou`}>
            <h1 dangerouslySetInnerHTML={{
                __html: t('LeadFormThankyouTitle')
            }}/>
            <p dangerouslySetInnerHTML={{
                __html: t('LeadFormThankyouMessage')
            }}/>
        </div>
    )

}

export default FormLayerThankyou;